const setInfoText = (text) => {
  return { type: "SET_INFO_TEXT", payload: text };
};

export default setInfoText;
